<template>
  <section>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
            <li class="m-nav__item">
              <router-link :to="{ name: 'home' }">
                <span class="m-nav__link-text">
                  <i class="m-nav__link-icon la la-home"></i>
                </span>
              </router-link>
            </li>
            <li class="m-nav__separator">
              >
            </li>
            <li class="m-nav__item">
              <span class="m-nav__link-text">
                {{ 'advance_search' | translate | titleize }}
              </span>
            </li>
            <li class="m-nav__separator">
              >
            </li>
            <li class="m-nav__item">
              <span class="m-nav__link-text">
                {{ 'forced_traceability_module' | translate | titleize }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="m-content" id="content">
      <div class="m-portlet m-portlet--mobile">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon">
                <i class="flaticon-search"></i>
              </span>
              <h3 class="m-portlet__head-text">
                {{ 'forced_traceability_module' | translate | capitalize }}
              </h3>
            </div>
          </div>
        </div>
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <div class="col-lg-4">
              <label for="identification_number">{{ 'identification_number' | translate | capitalize }}</label>
              <input id="identification_number" type="text" v-model="person_document" name="identification_number"
                class="form-control m-input">
            </div>
            <div class="col-lg-4">
              <label for="registered_plate">{{ 'registered_plate' | translate | capitalize }}</label>
              <input id="registered_plate" type="text" v-model="registered_plate" name="registered_plate"
                class="form-control m-input">
            </div>
            <div class="col-lg-4">
              <label for="date_start">{{ 'start_date' | translate | capitalize }}</label>
              <s-date-time-picker :id="'date_start'" :name="'date_start'" v-model="date_start" :options="config.start"
                @empty="date_start = $event"></s-date-time-picker>
            </div>
            <div class="col-lg-4">
              <label for="date_end">{{ 'end_date' | translate | capitalize }}</label>
              <s-date-time-picker :id="'date_end'" :name="'date_end'" v-model="date_end" :options="config.end"
                @empty="date_end = $event"></s-date-time-picker>
            </div>
            <div class="col-lg-4">
              <label>&nbsp;</label><br>
              <button class="btn btn-success" id="btn-cancel" @click="filter">
                <i class="la la-search"></i>
                <span>{{ 'search' | translate | capitalize }}</span>
              </button>
            </div>
          </div>
          <div class="m-portlet__body datatable-padding">
            <s-datatable :config="datatable">
              <div slot="actions" slot-scope="props">
                <a :title="messagePicturesTooltip"
                  class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_info"
                  data-toggle="modal" data-backdrop="static" data-keyboard="false"
                  data-target="#movement_pictures_modal" @click="getMovementImages(props.row.id)">
                  <i class="fa fa-camera"></i>
                </a>
              </div>
            </s-datatable>
          </div>
        </div>
      </div>
    </div>
    <s-modal id="movement_pictures_modal" :title="'movement_pictures' | translate | capitalize" :close_header="true"
      :size="'modal-lg modal-dialog-centered'">
      <div class="modal-body" slot="body">
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" v-if="movsImages.length > 0">
          <ol class="carousel-indicators">
            <li data-target="#carouselExampleIndicators" v-for="(img, indexLi) of movsImages" :data-slide-to="indexLi"
              :class="{ active: indexLi == 0 }" :key="indexLi"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item" v-for="(img, index) of movsImages" :key="index" :class="{ active: index == 0 }">
              <div class="container">
                <div class="row">
                  <img class="d-block w-100" :src="img" alt="First slide">
                </div>
                <div class="row">
                  <div class="col-md-3"></div>
                  <div class="col-md-3"></div>
                  <div class="col-md-3">
                    <button class="btn btn-outline-info dowload-image-btn" id="btn-download"
                      @click="downLoadImage(img, 'Foto_acceso_' + index + '.jpg')">
                      <i class="fa fa-download"></i>
                      <span>{{ 'download_file' | translate | capitalize }}</span>
                    </button>
                    <a ref="download" v-show="false" :href="downloadUrl" :download="downloadfilename"></a>
                  </div>
                  <div class="col-md-3"></div>
                </div>
              </div>
            </div>
          </div>
          <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div class="alert alert-primary" role="alert" v-else>
          {{ 'empty_mov_images' | translate | titleize }}
        </div>
      </div>
    </s-modal>
  </section>
</template>
<script>
import SDatatable from '@/components/layout/datatable/Datatable.vue'
import SModal from '@/components/layout/modal/Modal.vue'
import { mapActions } from 'vuex'
export default {
  components: { SDatatable, SModal },
  data() {
    return {
      datatable: {},
      person_document: '',
      registered_plate: '',
      config: {
        start: {
          format: 'yyyy-mm-dd',
          minView: 2
        },
        end: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: ''
        }
      },
      date_start: moment().format('YYYY-MM-DD'),
      date_end: moment().format('YYYY-MM-DD'),
      is_responsible: false,
      messagePicturesTooltip: this.$options.filters.capitalize('movement_photo'),
      auth_type_profiles: [],
      movsImages: [],
      downloadUrl: null,
      downloadfilename: null
    }
  },
  computed: {

  },
  methods: {
    ...mapActions(['advanceSearchPerson', 'getMoveImages']),
    filter() {
      this.datatable.update = true
      this.datatable.query = {
        person_document: this.person_document,
        date_start: this.date_start === '' ? moment().format('YYYY-MM-DD') : `${this.date_start}`,
        date_end: this.date_end === '' ? '' : `${this.date_end}`,
        registered_plate: this.registered_plate
      }
    },
    getMovementImages(movement_id) {
      this.movsImages = []
      this.$spinner.show()
      this.getMoveImages(movement_id)
        .then((res) => {
          this.movsImages = res.data.paths
          this.$spinner.remove()
        }).catch((err) => {
          this.$spinner.remove()
          console.log(err)
        })
    },
    downLoadImage(imgUrl, imgName) {
      this.downloadUrl = imgUrl
      this.downloadfilename = imgName
      setTimeout(() => {
        this.$refs.download[0].click()
      }, 200)
    }
  },
  created() {

  },
  mounted() {
    const self = this
    const datatable = {
      url: '/api/advance_search/forced',
      method: 'POST',
      size: 15,
      columns: [
        {
          field: 'NAME',
          title: 'first_name',
          template(row) {
            return `${row.NAME}`
          }
        },
        {
          field: 'IDENTIFICATION',
          title: 'by_identification',
          template(row) {
            return `${row.IDENTIFICATION}`
          }
        },
        {
          field: 'CREDENTIAL',
          title: 'credencial',
          template(row) {
            return `${row.CREDENTIAL_TYPE} ${row.CREDENTIAL}`
          }
        },
        {
          field: 'PLATE',
          title: 'plate',
          template(row) {
            return row.PLATE === null ? 'No aplica' : row.PLATE
          }
        },
        {
          field: 'DATE',
          title: 'date',
          template(row) {
            let date_time = row.DATE_TIME.replace('T', ' ').substring(0, row.DATE_TIME.indexOf('.'))
            let date = date_time.split(' ')[0]
            return date
          }
        },
        {
          field: 'TIME',
          title: 'time',
          template(row) {
            let date_time = row.DATE_TIME.replace('T', ' ').substring(0, row.DATE_TIME.indexOf('.'))
            let time = date_time.split(' ')[1]
            return time
          }
        },
        {
          field: 'DEVICE',
          title: 'control_points',
          template(row) {
            return `${row.DEVICE}`
          }
        },
        {
          field: 'WAY',
          title: 'sense',
          template(row) {
            return row.WAY === 1 ? self.$options.filters.capitalize('in') : self.$options.filters.capitalize('out')
          }
        },
        {
          field: 'EVENT',
          title: 'event',
          template(row) {
            return self.$options.filters.capitalize(row.EVENT.toLowerCase())
          }
        }],
      actions: true,
      update: false,
      query: {
        person_document: this.person_document,
        date_start: this.date_start === '' ? moment().format('YYYY-MM-DD') : `${this.date_start}`,
        date_end: this.date_end === '' ? moment().format('YYYY-MM-DD') : `${this.date_end}`,
        registered_plate: this.registered_plate
      }
    }
    this.datatable = datatable
  },
  watch: {
    date_start() {
      this.$set(this.config.end, 'startDate', this.date_start)
      if (this.date_start > this.date_end) {
        this.date_end = this.date_start
      }
    }
  }
}
</script>
<style>
.swal-button.swal-button--cancel {
  color: #555;
  background-color: #efefef;
  font-size: 12px;
  border: 1px solid #3e549a;
  text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
}

.swal-button.swal-button--accept {
  border-radius: 2px;
  background-color: #D21717;
  font-size: 12px;
  border: 1px solid #3e549a;
  text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
}

.datatable-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.dowload-image-btn {
  margin-top: 0.5rem;
  margin-left: 5rem;
}
</style>



// WEBPACK FOOTER //
// Forced.vue